import Axios from "axios";

import {
  SET_DASHBOARD_DATA,
  GET_EXAM_ROUTIN_AT_ADMIN_DASHBOARD,
  EXAM_ACTIVITY_DASHBOARD,
  SHONALI_SHEBA_DATA
} from "../../mutation-types";

import {
  adminDashboardUrl,
  AdminExamRoutinData,
  examActivityDashboard,
  updateViewData,
  shonaliShebaData,
  downloadExamSummaryDashboard
} from "../../api";

const state = {
  adminDashboardData: [],
  totalStatus: {
    total_center: "",
    total_invigilator: "",
    total_user: "",
    total_regional_center: "",
    exams_status: [],
  },
  examActivityData: [],
  shonaliShebaData: [],

};
const getters = {
  getDashboardData(state) {
    return state.totalStatus;
  },

  getAdminDashboardRoutin(state) {
    return state.adminDashboardData;
  },
  getExamActivityData(state) {
    return state.examActivityData;
  },
  getShonaliShebaData(state) {
    return state.shonaliShebaData;
  },
};
// mutations
const mutations = {
  [SET_DASHBOARD_DATA](state, response) {
    state.totalStatus = response;
  },

  [GET_EXAM_ROUTIN_AT_ADMIN_DASHBOARD](state, response) {
    state.adminDashboardData = response;
  },

  [EXAM_ACTIVITY_DASHBOARD](state, response) {
    state.examActivityData = response;
  },
  [SHONALI_SHEBA_DATA](state, response) {
    state.shonaliShebaData = response;
  },
};
// Actions
const actions = {
  getRoutineAtAdminDashboard({ commit }, date) {

    return Axios.get(AdminExamRoutinData, { params: date })
      .then(function (response) {
        var routine = response.data;
        commit("GET_EXAM_ROUTIN_AT_ADMIN_DASHBOARD", routine);
        return routine;
      })
  },
  getExamActivityDashboard({
    commit
  }) {
    return Axios.get(examActivityDashboard)
      .then(function (response) {
        var result = response.data;
        commit("EXAM_ACTIVITY_DASHBOARD", result);
        return result;
      })
  },
  getShonaliShebaData({ commit }, date) {
    return Axios.get(shonaliShebaData, { params: date })
      .then(function (response) {
        var result = response.data.data;
        commit("SHONALI_SHEBA_DATA", result);
        return result;
      })
  },
  getDashData({
    commit
  }) {
    return new Promise((resolve, reject) => {
      Axios.get(adminDashboardUrl)
        .then(function (response) {
          console.log("res", response);
          var result = response.data.data;
          commit("SET_DASHBOARD_DATA", result);
          resolve();
        })
        .catch(function (error) {
          console.log(error);
          reject();
        });
    });
  },
  updateViewData: ({ commit }, payload) => {
    commit("SET_LOADING", {
      color: "primary"
    });

    return new Promise((resolve, reject) => {
      Axios.post(updateViewData, payload)

        .then(response => {
          if (response.data.status === "success") {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Data updated successfully",
              color: "green"
            });
            resolve(response);
          } else {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Update failed",
              color: "red"
            });
            reject(new Error(response.data.message || "Update failed"));
          }
        })

        .catch(error => {
          let msg = "Update failed";

          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msg = error.response.data.message;
          }

          commit("SET_SNACKBAR", {
            msg: msg,
            color: "red"
          });

          commit("SET_RETURN_MESSAGE", msg);

          reject(error);
        })

        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },



  downloadDashboardExamSummary({ commit }, date) {
    return new Promise((resolve, reject) => {
      console.log("huddCurrent Date", date);
      Axios.get(downloadExamSummaryDashboard, {
        params: date,
        responseType: "blob"
      })
        .then(async response => {
          const contentType =
            response.headers["content-type"] || "";

          // Backend returned JSON instead of Excel
          if (contentType.includes("application/json")) {
            const text = await response.data.text();
            const data = JSON.parse(text);

            if (data.status === "success") {
              commit("SET_SNACKBAR", {
                msg: data.message || "Data downloaded successfully",
                color: "green"
              });

              resolve(response);
            } else {
              const msg =
                data.message || "Download failed";

              commit("SET_SNACKBAR", {
                msg: msg,
                color: "red"
              });

              commit("SET_RETURN_MESSAGE", msg);

              reject(new Error(msg));
            }

            return;
          }

          // Excel file
          const blob = new Blob(
            [response.data],
            {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
          );

          let filename = `${date}-exam-summary-dashboard.xlsx`;

          const disposition =
            response.headers["content-disposition"];

          if (disposition) {
            const match = disposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            );

            if (match && match[1]) {
              filename = match[1].replace(/['"]/g, "");
            }
          }

          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = filename;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          window.URL.revokeObjectURL(url);

          commit("SET_SNACKBAR", {
            msg: "Exam summary downloaded successfully",
            color: "green"
          });

          resolve(response);
        })
        .catch(error => {
          let msg = "Download failed";

          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msg = error.response.data.message;
          }

          commit("SET_SNACKBAR", {
            msg: msg,
            color: "red"
          });

          commit("SET_RETURN_MESSAGE", msg);

          reject(error);
        });
    });
  },




};

export default {
  state,
  getters,
  actions,
  mutations,
};